import {
  StatusOV,
  type StatusOVKeys,
  statusToReturnOvFromSap,
  statusToReturnToSalesArea,
  statusToSendOvToSap,
} from 'container/Home/components/Banners/interface'
import { toast } from 'react-toastify'
import type {
  RequestOvSap,
  SapOptionsToOvStatus,
  SapTypeToOvStatus,
} from 'store/OVContext/ovContextTypes'

export type OvDataToSap = {
  number: string
  changeDate: string
  statusKey: StatusOVKeys
}

export const verifyOvStatusToSap = (ovList: OvDataToSap[], ruleList: StatusOVKeys[]): boolean =>
  ovList.every((ov) => ruleList.includes(ov.statusKey))

export const getValidSapBody = (ovList: OvDataToSap[]): RequestOvSap['body'] =>
  ovList.map((ov) => ({
    dataAlteracao: ov.changeDate,
    numeroOrdemVenda: ov.number,
  }))

export const getOvStatusOptionsToSap = (ovList: OvDataToSap[]): SapOptionsToOvStatus => {
  const isValidToSend = verifyOvStatusToSap(ovList, statusToSendOvToSap)
  if (isValidToSend) {
    return {
      body: getValidSapBody(ovList),
      isValidToReturnFromSap: false,
      isValidToReturnToSalesArea: false,
      isValidToSendToSap: isValidToSend,
      type: 'enviar',
    }
  }
  const isValidToReturn = verifyOvStatusToSap(ovList, statusToReturnOvFromSap)
  if (isValidToReturn) {
    return {
      body: getValidSapBody(ovList),
      isValidToReturnFromSap: isValidToReturn,
      isValidToReturnToSalesArea: false,
      isValidToSendToSap: false,
      type: 'retornar',
    }
  }
  const isValidToSalesArea = verifyOvStatusToSap(ovList, statusToReturnToSalesArea)
  if (isValidToSalesArea) {
    return {
      body: getValidSapBody(ovList),
      isValidToReturnFromSap: false,
      isValidToReturnToSalesArea: isValidToSalesArea,
      isValidToSendToSap: false,
      type: 'devolver',
    }
  }
  return {
    isValidToReturnFromSap: false,
    isValidToReturnToSalesArea: false,
    isValidToSendToSap: false,
  }
}

export const getOvStatusKey = (status: number): StatusOVKeys | undefined =>
  Object.keys(StatusOV).find((keys) => Number(keys.split('-')[0]) === status) as
    | StatusOVKeys
    | undefined

export const sapSuccessToast = (type: SapTypeToOvStatus): string | number | undefined => {
  if (type === 'devolver') return toast.success('OV devolvida para área de vendas.')
  if (type === 'enviar') return toast.success('OV enviada com sucesso.')
  if (type === 'retornar') return toast.success('OV retornada com sucesso.')
}

export const sendOVErrors = {
  bind: 'INFORMAR OVS DE REFERÊNCIA PARA A OV BONIFICADA',
  file: 'OV BONIFICADA DEVE CONTER ANEXO',
  nd: 'FAVOR JUSTIFICAR A ORDEM DE VENDA - NEGOCIAÇÃO DIFERENCIADA.',
  nf: 'FAVOR INFORMAR O TEXTO PARA ORDEM DE VENDA, POIS ESSA ORDEM DE VENDA É BONIFICADA.',
}

export const sendErrorToast = (message: string) => {
  if (message === sendOVErrors.nd)
    return toast.error(
      'Não foi possível enviar essa OV pois a justificativa de ND não foi preenchida.',
    )
  if (message === sendOVErrors.nf)
    return toast.error(
      'Não foi possível enviar essa OV pois o texto de Nota Fiscal não foi preenchido.',
    )
  if (message === sendOVErrors.bind)
    return toast.error('Não foi possível enviar essa OV pois não há nenhuma OV YPEM vinculada.')
  if (message === sendOVErrors.file)
    return toast.error(
      'Não foi possível enviar essa OV pois não há arquivo anexado na justificativa.',
    )
}
